<template>
  <div class="verification-header">
    <p class="title">{{ title }}</p>
    <p class="desc">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'VerificationHeader',
  props: {
    title: {
      type: String,
      default: '身份验证'
    },
    description: {
      type: String,
      default: '为保证你的账号安全，请验证身份，验证成功后可进行操作'
    }
  }
}
</script>

<style lang="scss" scoped>
.verification-header {
  color: #333333;

  .title {
    font-weight: 600;
    font-size: 16px;

  }
  .desc {
    margin-top: 14px;
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
